"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class BillingService {
    /**
     * @param requestBody
     * @returns CreatePayment
     * @throws ApiError
     */
    static createPaymentCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/create_payment/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaymentHistory
     * @throws ApiError
     */
    static paymentHistoryList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/payment_history/',
        });
    }
    /**
     * @returns Payment
     * @throws ApiError
     */
    static statusPaymentRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/status_payment/',
        });
    }
}
exports.BillingService = BillingService;
